<style scoped>
.logo-default {
  height: 65px;
  margin-top: 5px !important;
}

.page-logo h3 {
  line-height: 40px;
  font-weight: 400;
  color: #666;
}
</style>
<template>
  <div class="page-wrapper-row">
    <div class="page-wrapper-top">
      <div class="page-header">
        <div class="page-header-top">
          <div class="container-fluid">
            <div class="page-logo">
              <div class="pull-left">
                <img src="../../assets/images/logo.png" alt="logo" class="logo-default">
              </div>
              <h3>&nbsp; Product Tools</h3>
            </div>

            <div class="top-menu" v-if="$parent.isAuthenticated">
              <ul class="nav navbar-nav pull-right">
                <li class="dropdown dropdown-user dropdown-dark">
                  <a
                    v-on:click="$parent.$router.push('/profile')"
                    class="dropdown-toggle"
                    data-toggle="dropdown"
                    data-hover="dropdown"
                    data-close-others="true"
                  >
                    <img alt class="img-circle" :src="profile.picture">
                    <span class="username username-hide-mobile">{{profile.name}}</span>
                  </a>
                </li>
                <li class="droddown dropdown-separator">
                  <span class="separator"></span>
                </li>
                <li class="dropdown dropdown-extended quick-sidebar-toggler">
                  <i title="Log Out" class="icon-logout" v-on:click="$parent.logout()"></i>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <PageMenu :isAuthenticated="$parent.isAuthenticated"></PageMenu>
      </div>
    </div>
  </div>
</template>

<script>
import PageMenu from "@/components/Layout/PageMenu";
export default {
  components: { PageMenu },
  props: ["profile"],
  name: "PageHeader"
};
</script>
